import {
  Directive,
  ElementRef,
  HostListener,
  input,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective implements OnDestroy {
  appTooltip = input.required<string>();

  private tooltipEl: HTMLElement | null = null;

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.tooltipEl) return;

    const el = document.createElement('div');
    el.className = 'tooltip';
    el.textContent = this.appTooltip();
    el.style.whiteSpace = 'nowrap';
    el.style.fontSize = '12px';
    document.body.appendChild(el);
    this.tooltipEl = el;

    const hostRect = this.elRef.nativeElement.getBoundingClientRect();
    const tooltipRect = el.getBoundingClientRect();

    el.style.top = `${hostRect.top - tooltipRect.height - 6 + window.scrollY}px`;
    el.style.left = `${hostRect.left + hostRect.width / 2 - tooltipRect.width / 2 + window.scrollX}px`;
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.removeTooltip();
  }

  constructor(private elRef: ElementRef) {}

  ngOnDestroy(): void {
    this.removeTooltip();
  }

  private removeTooltip(): void {
    if (this.tooltipEl) {
      this.tooltipEl.remove();
      this.tooltipEl = null;
    }
  }
}
